module.exports = __webpack_public_path__ + "img/11.55feef4d.jpg";